<template>
  <div>
    <b-row class="mb-2">
      <b-col>
        <b-card
          body-class="p-2 d-flex flex-column flex-sm-column flex-md-row justify-content-between"
          class="shadow-sm"
          border-variant="white"
        >
          <h4 class="m-0 font-weight-bold text-center text-md-left">
            <i class="fas fa-list"></i> รายการที่แทง
          </h4>
          <div>
            <b-badge variant="warning" class="goldenrod w-100">ผลรางวัลออกเลขตามสลากหวยรัฐบาลไทย</b-badge>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <b-card body-class="m-0 px-3 py-0" class="shadow-sm my-2" border-variant="dark" v-for="(item,index) in items" v-bind:key="item.id">
          <b-row>
            <b-col cols="3" sm="2" class="bg-secondary text-white text-center d-flex align-items-center justify-content-center">
              <div>
              ลำดับ
              <h5 class="text-white font-weight-bold mb-0">{{index + 1}}</h5>
              </div>
            </b-col>
            <b-col cols="6" sm="8" class="bg-light text-center d-flex flex-wrap align-items-center justify-content-center col-sm-8 col-6">
              <div class="px-2" v-for="(number,index) in item.numbers" v-bind:key="index">
                <h4 :class="['font-weight-bold mb-0', number.isWon ? 'text-success' : '']">{{number.betNumber}} <i class="far fa-check-circle" v-if=" number.isWon"></i></h4>
              </div>
            </b-col>
            <b-col cols="3" sm="2" class="px-0 bg-warning text-center d-flex align-items-center" v-if="item.status == 1">
              <div class="text-center w-100">
                <i class="fas fa-circle-notch fa-xs fa-spin"></i>&nbsp;
                <small>{{getStatus(item.status)}}</small>
              </div>
            </b-col>
            <b-col cols="3" sm="2" class="px-0 bg-success text-center d-flex align-items-center" v-else-if="item.status == 2">
              <div class="text-center w-100 text-white">
                <i class="far fa-check-circle"></i>&nbsp;
                <small>{{getStatus(item.status)}}</small>
              </div>
            </b-col>
            <b-col cols="3" sm="2" class="px-0 bg-danger text-center d-flex align-items-center" v-else-if="item.status == 3">
              <div class="text-center w-100 text-white">
                <i class="far fa-check-circle"></i>&nbsp;
                <small>{{getStatus(item.status)}}</small>
              </div>
            </b-col>
            <b-col cols="3" sm="2" class="px-0 bg-secondary text-center d-flex align-items-center" v-else-if="item.status == 4">
              <div class="text-center w-100 text-white">
                <i class="fas fa-ban"></i>&nbsp;
                <small>{{getStatus(item.status)}}</small>
              </div>
            </b-col>
            <b-col cols="6" sm="3" md="2" class="py-2 bg-dark text-white text-center d-flex align-items-center justify-content-start justify-content-sm-center">
              <small>No. #{{item.id}}</small>
            </b-col>
            <b-col cols="6" sm="3" class="py-2 bg-dark text-white text-center d-flex align-items-center justify-content-end justify-content-sm-center">
              <small>ซื้อเมื่อ {{item.buyingDate}}</small>
            </b-col>
            <b-col cols="6" sm="3" class="py-2 bg-dark text-white text-center d-flex align-items-center justify-content-start justify-content-sm-center">
              <small></small>
            </b-col>            
            <b-col cols="6" sm="3" md="2" class="py-2 bg-dark text-white text-right d-flex align-items-center justify-content-end">
              <small>มูลค่า {{getAmount(item.unitPrice)}} ชุด</small>
            </b-col>
            <b-col cols="12" sm="3" md="2" class="py-2 bg-light text-right d-flex align-items-center justify-content-center justify-content-sm-end">
              <small>ราคา</small><strong class="px-2">{{item.unitPrice}}</strong><small>P</small>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  name: "Poy",
  props: ['lottoInfo', 'lottoType'],
  data() {
          console.log("ReferID",this.lottoInfo);
    return {
      items: []
    }
  },  
  mounted() {
    this.getMyLottoSetBet();
  },
  methods: {
    getMyLottoSetBet() {
      console.log("ReferID",this.lottoInfo);
      axios
        .post(
          this.getApiUrl + "/jackpot/bet",
          {
            lottoType: this.lottoType,
            referID: this.lottoInfo.lottoResultId,
            username: this.getUsername
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername
            }
          }
        )
        .then(response => {
          this.items = response.data.data;
          console.log(this.items);
        });
    },
    getAmount(numbers) {
      return numbers;
    },
    getStatus(status)
    {
      if(status == 1)
      {
        return "รอประกาศผล";
      }
      else if(status == 2)
      {
        return "ประกาศผลแล้ว";
      }
      else if(status == 3)
      {
        return "ไม่ถูกรางวัล";
      }
      else if(status == 4)
      {
        return "ยกเลิก";
      }
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getApiUrl: "getApiUrl"
    })
  }
};
</script>

<style lang="scss" scoped>
.goldenrod {
  background-color: goldenrod;
  font-weight: normal;
  color: #fff;
}

.text-gold {
  color: rgb(189, 132, 41) !important;
}

.gold-box {
  background-image: linear-gradient(
    160deg,
    #a54e07,
    #b47e11,
    #fef1a2,
    #bc881b,
    #a54e07
  );
  border: 1px solid #a55d07 !important;
  text-shadow: black 1px 1px 3px;
}

.font-mitr {
  font-family: "Mitr", sans-serif;
}
</style>